import React from 'react';
import logo from '../logo-white-x1024.png';
import { Link } from 'react-router-dom';

export default function Header({ navHeight, fixed }) {
	return (
		<header className={fixed ? 'fixed' : ''}>
			<nav
				id="navbar"
				className={fixed ? 'fixed' : ''}
				style={{
					height: Math.max(64, Math.min(96, navHeight ?? 64)),
				}}>
				<div className="nav-inner">
					<Link to="/" className="nav-logo-link">
						<img
							src={logo}
							alt="DJ Aconitum"
							className="nav-logo"
						/>
					</Link>
					<ul>
						<li>
							<Link to="/">Home</Link>
						</li>
						<li>
							<Link to="/contact">Contact</Link>
						</li>
						<li>
							<Link to="/privacy-policy">Privacy</Link>
						</li>
					</ul>
				</div>
			</nav>
		</header>
	);
}
